<section id="title">
  <div class="_circles"></div>
  <h1 class="animate__animated animate__delay-2s fadeInUp">elapp</h1>
  <el-piano-app></el-piano-app>
</section>
